import { createSlice } from '@reduxjs/toolkit';

// Utility function to save data to localStorage
const saveToLocalStorage = (key, data) => {
  window.localStorage.setItem(key, JSON.stringify(data));
};

// Utility function to remove data from localStorage
const removeFromLocalStorage = (key) => {
  window.localStorage.removeItem(key);
};

// Utility function to get user data from localStorage
const getUserFromLocalStorage = () => {
  try {
    const data = window.localStorage.getItem('user');
    return data ? JSON.parse(data) : null;
  } catch {
    window.localStorage.removeItem('user');
    return null;
  }
};

const initialState = {
  user: getUserFromLocalStorage(),  // Initialize from localStorage
  name: '',
  loading: false,
  action: null,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signIn: (state, action) => {
      state.user = action.payload;
      state.name = action.payload.name;
      saveToLocalStorage('user', action.payload); // Save to localStorage
    },
    googleSignIn: (state, action) => {
      state.user = action.payload;
      state.name = action.payload.name;
      saveToLocalStorage('user', action.payload); // Save to localStorage
    },
    logOut: (state) => {
      state.user = null;
      state.name = '';
      state.error = null;
      removeFromLocalStorage('user'); // Remove from localStorage
    },
    loadingTrue: (state) => {
      state.loading = true;
    },
    loadingFalse: (state) => {
      state.loading = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setUserFromLocalStorage: (state) => {
      const userFromLocalStorage = getUserFromLocalStorage();
      if (userFromLocalStorage) {
        state.user = userFromLocalStorage;
        state.name = userFromLocalStorage.name;
      } else {
        state.user = null;
        state.name = '';
      }
    },
    updateUser: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
        if (action.payload.name) {
          state.name = action.payload.name;
        }
        saveToLocalStorage('user', state.user);
      }
    }
  },
});

export const { signIn, googleSignIn, logOut, loadingTrue, loadingFalse, setError, clearError, setUserFromLocalStorage, updateUser } = userSlice.actions;

export default userSlice.reducer;
